module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Git-3-eb66d780a70290860e04fc8c292c7f4a.svg";